import { userEmpower, errors } from '@/services';

export default {
	namespaced: true,
	state: {
		userPowerType: 0, // 0-无授权 1-旗舰版 2-尊享版 3-企业版
		userIsUnLimitedUser: 0, // 是否处于免流期间，
		activityUserPowerType: 0, // 0-无授权 1-旗舰版 2-尊享版 3-企业版
		activityUserIsUnLimitedUser: 0, // 是否处于免流期间，
		activityCustomInvitationCard: 0, // 直播间是否开启定制邀请卡授权
	},
	mutations: {
		SET_USER_POWER_TYPE(state, type) {
			state.userPowerType = type;
		},
		SET_USER_IS_UN_LINITE_USER(state, status) {
			state.userIsUnLimitedUser = status;
		},
		SET_ACTIVITY_USER_POWER_TYPE(state, type) {
			state.activityUserPowerType = type;
		},
		SET_ACTIVITY_USER_IS_UN_LINITE_USER(state, status) {
			state.activityUserIsUnLimitedUser = status;
		},
		SET_ACTIVITY_CUSTOM_INVITATION_CARD(state, status) {
			state.activityCustomInvitationCard = status;
		},
	},
	actions: {
		async getUserPowerType({ commit }, userId) {
			try {
				const { data, ok } = await userEmpower.getEmpowerTypeForUserId(userId);
				if (!ok) {
					return;
				}
				const { empowerType, isUnlimitedUser } = data.data;
				commit('SET_USER_POWER_TYPE', empowerType);
				commit('SET_USER_IS_UN_LINITE_USER', isUnlimitedUser);
			} catch (error) {
				errors(error);
			}
		},
		async getActivityUserPowerType({ commit }, userId) {
			console.log('activity userId', userId);
			try {
				const { data, ok } = await userEmpower.getEmpowerTypeForUserId(userId);
				if (!ok) {
					return;
				}
				const { empowerType, isUnlimitedUser, customInvitationCard } = data.data;
				commit('SET_ACTIVITY_USER_POWER_TYPE', empowerType);
				commit('SET_ACTIVITY_USER_IS_UN_LINITE_USER', isUnlimitedUser);
				commit('SET_ACTIVITY_CUSTOM_INVITATION_CARD', customInvitationCard ? 1 : 0);
			} catch (error) {
				errors(error);
			}
		},
	},
};
